"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../tracker");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var modal_1 = require("./modal");
var signin_form_1 = require("./signin_form");
var signup_form_1 = require("./signup_form");
var COMPONENT_NAME = 'SignupSigninModal';
var SignupSigninModal = /** @class */ (function (_super) {
    tslib_1.__extends(SignupSigninModal, _super);
    function SignupSigninModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSignup: true,
        };
        return _this;
    }
    SignupSigninModal.prototype.switchToSignup = function () {
        this.setState({ showSignup: true });
    };
    SignupSigninModal.prototype.switchToLogin = function () {
        this.setState({ showSignup: false });
    };
    Object.defineProperty(SignupSigninModal.prototype, "trackContext", {
        get: function () {
            return {
                source: this.props.trackSource,
                view: this.state.showSignup ? 'signup' : 'signin',
            };
        },
        enumerable: true,
        configurable: true
    });
    SignupSigninModal.prototype.componentDidMount = function () {
        if (this.props.active) {
            this.trackView();
        }
    };
    SignupSigninModal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.active && !prevProps.active) {
            this.trackView();
        }
    };
    SignupSigninModal.prototype.trackView = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.VIEW,
            context: this.trackContext,
            mParticleView: {
                source: this.trackContext.source,
                view: this.trackContext.view,
                eventName: mparticle_tracker_1.MParticleEventName.ViewedSignupSignin,
            },
        });
    };
    SignupSigninModal.prototype.renderForm = function () {
        var redirectTo = this.props.redirectTo;
        if (this.state.showSignup) {
            return React.createElement(signup_form_1.default, { onToggle: this.switchToLogin, redirectTo: redirectTo, shouldRenderHeader: this.shouldRenderHeader(), trackName: "SignupSigninModal", trackContext: this.trackContext });
        }
        return React.createElement(signin_form_1.default, { onToggle: this.switchToSignup, redirectTo: redirectTo, shouldRenderHeader: this.shouldRenderHeader(), trackName: "SignupSigninModal", trackContext: this.trackContext });
    };
    SignupSigninModal.prototype.shouldRenderHeader = function () {
        return !this.props.messageComponent && !this.props.message;
    };
    SignupSigninModal.prototype.renderMessage = function () {
        if (this.props.onlyShowMessageForSignup && !this.state.showSignup)
            return;
        if (this.props.messageComponent) {
            return this.props.messageComponent;
        }
        if (this.props.message) {
            return (React.createElement("div", { className: "alert-box size-90 scaling-mb-2" }, this.props.message));
        }
        return null;
    };
    SignupSigninModal.prototype.render = function () {
        return (React.createElement(modal_1.default, { isOpen: this.props.active, onRequestClose: this.props.onRequestClose },
            React.createElement("div", { className: "signup-signin" },
                React.createElement("div", { className: "signup-signin__tabs" },
                    React.createElement("a", { className: classNames('signup-signin__tab', {
                            'signup-signin__tab--active': this.state.showSignup,
                        }), onClick: this.switchToSignup }, I18n.t('commons.signupForm.signUp')),
                    React.createElement("a", { className: classNames('signup-signin__tab', {
                            'signup-signin__tab--active': !this.state.showSignup,
                        }), onClick: this.switchToLogin }, I18n.t('commons.signupForm.logIn'))),
                React.createElement("div", { className: "signup-signin__form" },
                    this.renderMessage(),
                    this.renderForm()))));
    };
    SignupSigninModal.defaultProps = {
        redirectTo: window.location.href,
    };
    tslib_1.__decorate([
        bind_1.default
    ], SignupSigninModal.prototype, "switchToSignup", null);
    tslib_1.__decorate([
        bind_1.default
    ], SignupSigninModal.prototype, "switchToLogin", null);
    SignupSigninModal = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME })
    ], SignupSigninModal);
    return SignupSigninModal;
}(React.Component));
exports.default = SignupSigninModal;
//# sourceMappingURL=signup_signin_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/signup_signin_modal.js
// module id = tbQp
// module chunks = 20 21